module.exports = __webpack_public_path__ + "img/yawaragi.b990d1e.png";